      <div class="section__checkbox-card">
            <div class="section__toggle-header">
              <div>
                <strong class="section__toggle-title">
                  {{title()}}
                  <span
                    libTooltip
                    tooltipPosition="bottom"
                    tooltipMessage=" Quando ativa, a categoria pode ser utilizada no cardápio e exibida nos fluxos permitidos."
                  >
                    <svg
                      class="section__info-icon"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <circle
                        class="section__info-icon-circle"
                        cx="12"
                        cy="12"
                        r="9"
                      />
                      <path
                        class="section__info-icon-line"
                        d="M12 10.5V16"
                      />
                      <circle
                        class="section__info-icon-dot"
                        cx="12"
                        cy="7.5"
                        r="1"
                      />
                    </svg>
                  </span>
                </strong>

                <p class="section__toggle-text"></p>
              </div>
            </div>
            <ng-content></ng-content>
          </div>